<template>
  <div class="contenedor">
    <LoadingSpinner v-if="loading" />
    <div v-else class="mx-2">
      <div class="" v-if="!loading">
        <div class="col-md-12 w-100 my-2 card p-2">
          <Modal :name="'businessModal'" :close="true">
            <SelectedContact
              :selectedContactId="selected_contact_id"
              :selectedBusinessId="false"
            ></SelectedContact>
          </Modal>
          <div class="col-md-12 mb-2" v-if="!loading">
            <div class="row">
              <vue-form-generator
                :schema="schemaStatus"
                :model="filters"
                :options="formOptions"
              ></vue-form-generator>
              <div class="col-md-2">
                <button
                  class="btn btn-sm btn-primary mr-2"
                  @click="filterNow()"
                >
                  Filtrer
                </button>
                <button class="btn btn-sm btn-primary" @click="resetFilter()">
                  Reset
                </button>
              </div>
            </div>
            <div class="row">
              <div
                v-for="(filter, index) in filters"
                class="ml-2"
                :key="indexf"
              >
                <span
                  class="badge badge-danger ml-2 text-white cursor-pointer"
                  @click="removeFilter(index)"
                >
                  <span v-if="labels[index]">{{ labels[index] }}</span
                  ><span v-else>{{ index }}</span> = {{ filter }}
                  <i class="icon-close"></i>
                </span>
                <!-- Agrega más condiciones según sea necesario para otros casos -->
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="accountemails.length > 0">
          <div class="d-flex justify-content-center w-100 px-3">
            <!-- Paginación centrada -->
            <Pagination
              v-if="!loading"
              :total="5000"
              :totalpage="accountemails.length"
              :model="paginationmodel"
              :limit="false"
              :color="'primary'"
              @changePage="changePage"
              key="323323"
            />
          </div>
        </div>

        <div class="col-md-12 w-100 my-2 card p-2">
          <div class="py-2 font-weight-bold">Total: {{ total }}</div>
          <div class="col-md-12">
            <div class="card scrollable">
              <Table
                v-if="accountemails.length > 0"
                :headers="headers"
                :cols="cols"
                :data="accountemails"
                :checkbox="selectcheckbox"
                :notselect="true"
                :model="model"
                :allselected="false"
                @searchSameLinkedin="searchSameLinkedin"
                @searchSameCompanyName="searchSameCompanyName"
                @searchSameEnterprise="searchSameEnterprise"
                @searchSameBC="searchSameBC"
                @searchSameBusiness="searchSameBusiness"
                @searchSameDomain="searchSameDomain"
                @editBusiness="editBusiness"
              >
              </Table>
            </div>

            <button
              class="btn btn-sm btn-danger"
              @click="deleteUser"
              v-if="selectcheckbox"
              :disabled="deleting"
            >
              Delete
            </button>
            <span
              v-if="deleting"
              class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Table from "@/components/Common/Table.vue";
import Modal from "@/components/Common/Modal.vue";
import AddDomainWorkspace from "@/components/Workspace/AddDomainWorkspace.vue";
import SelectedContact from "@/components/Businesses/SelectedContact.vue";
import DeleteDomains from "@/components/Workspace/DeleteDomains.vue";

import {
  adminService,
  businessContactsService,
  campaignsService,
  workspaceService,
  usersService,
  opportunitiesService,
} from "@/_services";
import VueFormGenerator from "vue-form-generator";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Pagination from "@/components/Common/Pagination.vue";

export default {
  props: {
    query: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      selected_business_id: false,
      selected_contact_id: false,
      showform: false,
      labels: {
        "b-name": "Business name",
        sent_amt: "Sent to apollo",
        "b-apollo_id": "Has business apollo ID",
        domain: "Business domain",
        enterprise: "Contact company name",
      },
      deleting: false,
      indexf: 333223323,
      selectcheckbox: false,
      keybuttondelete: 323432,
      keydomains: 23,
      sales_rep_id: false,
      addEmailUserId: false,
      workspace_domain: [],
      workspace_domain_aux: [],
      workspace_domain_id: false,
      total: false,
      accountemails: [],
      loading: true,
      model: {},
      paginationmodel: {
        currentPage: 1,
        cantPerPage: 50,
      },
      filters: {},
      cols: [],
      headers: [],
      clients: [],
      client_aux: [],
      client_status: [],
      client_status_aux: [],
      workspace_aux: [],
      workspace: [],
      provider: [],
      provider_aux: [],
      user_status: [],
      user_status_aux: [],
      schemaStatus: {
        fields: [
          {
            type: "input",
            inputType: "text",
            model: "email",
            placeholder: "ex : alice.lac@ateliersouchamp.com",
            featured: true,
            required: true,
            label: this.$t("lang.label.email"),
            styleClasses: "col-md-3",
          },
          {
            type: "input",
            inputType: "text",
            model: "domain",
            placeholder: "ex : cocacola.com",
            featured: true,
            required: true,
            label: "Domain (B)",
            styleClasses: "col-md-3",
          },
          {
            type: "input",
            inputType: "text",
            model: "b-name",
            placeholder: "ex : Coca cola",
            featured: true,
            required: true,
            label: "Company name (B)",
            styleClasses: "col-md-3",
          },
          {
            type: "input",
            inputType: "text",
            model: "enterprise",
            placeholder: "ex : Coca Cola",
            featured: true,
            required: true,
            label: "Company name (BC)",
            styleClasses: "col-md-3",
          },
          {
            type: "radios",
            values: () => {
              return ["Yes", "No"];
            },
            label: "Sent it to Apollo",
            model: "sent_amt",
            featured: false,
            styleClasses: "col-md-3",
          },
          {
            type: "radios",
            values: () => {
              return ["Yes", "No"];
            },
            label: "Business apollo ID",
            model: "b-apollo_id",
            featured: false,
            styleClasses: "col-md-3",
          },
          {
            type: "radios",
            values: () => {
              return ["Yes", "No"];
            },
            label: "With category linkedin",
            model: "cl-id",
            featured: false,
            styleClasses: "col-md-3",
          },
          {
            type: "radios",
            values: () => {
              return ["Yes", "No"];
            },
            label: "Without Linkedin URL",
            model: "b-linkedinurl",
            featured: false,
            styleClasses: "col-md-3",
          },
          {
            type: "select",
            inputType: "text",
            label: "Salaries",
            model: "salaries",
            readonly: false,
            required: true,
            disabled: false,
            selectOptions: {},
            values: () => {
              return [
                "1-10",
                "10-50",
                "50-200",
                "200-500",
                "500-1000",
                "1000-5000",
                "5000-10000",
                "10000-100000",
              ];
            },
            styleClasses: "col-sm-6 col-md-3",
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },
  components: {
    Table,
    "vue-form-generator": VueFormGenerator.component,
    LoadingSpinner,
    Pagination,
    Modal,
    SelectedContact,
  },

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
  },

  created() {
    if (this.query) {
      this.filters = this.query;
    } else {
      this.filters.sent_amt = "Yes";
      this.filters["b-apollo_id"] = "Yes";
    }

    this.cols = [
      [
        {
          value_label: "id",
          value_emit: "id",
          class: "text-primary",
          type: "emit",
          emit: "searchSameBC",
        },
      ],
      [
        {
          value: "email",
        },
      ],
      [
        {
          value: "status",
        },
      ],
      [
        {
          value: "bc_name",
        },
      ],
      [
        {
          value_label: "enterprise",
          value_emit: "enterprise",
          class: "text-primary",
          type: "emit",
          emit: "searchSameEnterprise",
        },
      ],
      [
        {
          value: "updated",
        },
      ],
      [
        {
          value: "bc_apollo_id",
        },
      ],
      [
        {
          value_label: "b_id",
          value_emit: "b_id",
          class: "text-primary",
          type: "emit",
          emit: "searchSameBusiness",
        },
        {
          label: "",
          value_emit: "id",
          class: "text-primary ml-2",
          type: "emit",
          icon: "icon-edit",
          emit: "editBusiness",
        },
      ],
      [
        {
          value_label: "b_name",
          value_emit: "b_name",
          class: "text-primary",
          type: "emit",
          emit: "searchSameCompanyName",
        },
      ],
      [
        {
          value_label: "linkedinurl",
          value_emit: "linkedinurl",
          class: "text-primary",
          type: "emit",
          emit: "searchSameLinkedin",
        },
      ],
      [
        {
          value: "cat_name",
        },
      ],
      [
        {
          value: "salaries",
        },
      ],
      [
        {
          value_label: "domain",
          value_emit: "domain",
          class: "text-primary mr-2",
          type: "emit",
          emit: "searchSameDomain",
        },
        {
          value: "url",
          link: "url",
          type: "link",
        },
      ],
      [
        {
          value: "created",
        },
      ],
      [
        {
          value: "location",
        },
      ],
      [
        {
          value: "b_apollo_id",
          link: "b_apollo_id_link",
          type: "link",
          class: "cursor-pointer",
        },
      ],
    ];
    this.headers = [
      {
        label: "BC id (BC)",
        size: "130",
        class: "overflowhide bg-light",
      },
      {
        label: "Email (BC)",
        size: "130",
        class: "overflowhide bg-light",
      },
      {
        label: "Status (BC)",
        size: "130",
        class: "overflowhide bg-light",
      },
      {
        label: "Name (BC)",
        size: "130",
        class: "overflowhide bg-light",
      },
      {
        label: "Company name (BC)",
        size: "130",
        class: "overflowhide bg-light",
      },
      {
        label: "Updated (BC)",
        size: "130",
        class: "overflowhide bg-light",
      },
      {
        label: "Apollo ID (BC)",
        size: "130",
        class: "overflowhide bg-info text-white",
      },
      {
        label: "Business id (B)",
        size: "130",
        class: "overflowhide ",
      },
      {
        label: "Company name (B)",
        size: "130",
        class: "overflowhide",
      },
      {
        label: "Linkedin URL (B)",
        size: "130",
        class: "overflowhide",
      },
      {
        label: "Category name (B)",
        size: "130",
        class: "overflowhide",
      },
      {
        label: "Salaries (B)",
        size: "130",
        class: "overflowhide",
      },
      {
        label: "Domain (B)",
        size: "130",
        class: "overflowhide",
      },
      {
        label: "Created (B)",
        size: "130",
        class: "overflowhide",
      },
      {
        label: "Location",
        size: "130",
        class: "overflowhide",
      },
      {
        label: "Apollo ID (B)",
        size: "130",
        class: "overflowhide bg-info text-white",
      },
    ];
    this.filterNow();

    this.getFilter();
  },
  methods: {
    filterNow() {
      this.paginationmodel["filters"] = [];
      for (const key in this.filters) {
        let alias = "";
        if (Object.hasOwnProperty.call(this.filters, key)) {
          const value = this.filters[key];
          let eq = key;
          if (eq.includes(".")) {
            let aliasarr = eq.split(".");
            alias = aliasarr[0];
            eq = aliasarr[1];
          } else {
            if (eq.includes("-")) {
              let aliasarr = eq.split("-");
              alias = aliasarr[0];
              eq = aliasarr[1];
            }
          }
          let val = value;
          let eq_par = "filter" + eq;
          let filter = {};

          if (val == "Yes") {
            val = "IS NOT NULL";
          }
          if (val == "No") {
            val = "IS NULL";
          }

          filter.eq = eq;
          filter.alias = alias;
          filter.value = val;
          filter.eq_par = eq_par;

          this.paginationmodel.filters.push(filter);
        }
      }

      this.getAccountEmails();
    },
    prepareAndFilter(value, eq_par) {
      this.filters[eq_par] = value;
      this.filterNow();
    },
    searchSameLinkedin(linkedinurl) {
      this.prepareAndFilter(linkedinurl, "b.linkedinurl");
    },
    searchSameCompanyName(name) {
      this.prepareAndFilter(name, "b.name");
    },
    searchSameEnterprise(enterprise) {
      this.prepareAndFilter(enterprise, "bc.enterprise");
    },
    searchSameBC(bc_id) {
      this.prepareAndFilter(bc_id, "bc.id");
    },
    searchSameBusiness(b_id) {
      this.prepareAndFilter(b_id, "b.id");
    },
    editBusiness(id) {
      this.selected_contact_id = id;
      this.$modal.show("businessModal");
    },
    searchSameDomain(b_domain) {
      this.prepareAndFilter(b_domain, "b.domain");
    },
    deleteUser(user_id) {
      if (this.model.selectedIds.length > 0) {
        let data = {
          users: this.model.selectedIds,
          fullDeleteDB: true,
        };
        this.deleting = true;
        usersService.deleteUsers(data).then((r) => {
          this.getAccountEmails();
          this.model.selectedIds = [];
          this.deleting = false;
        });
      }
    },
    getAccountEmails() {
      this.loading = true;

      this.selectcheckbox = false;
      businessContactsService
        .getBusinessContacts(this.paginationmodel)
        .then((result) => {
          this.accountemails = result.result;
          if (result.total == null) {
            this.total = 0;
          } else {
            this.total = result.total
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
          this.loading = false;
        });
    },
    changePage() {
      this.getAccountEmails();
    },
    resetFilter() {
      this.filters = {};
      this.paginationmodel = {
        currentPage: 1,
        cantPerPage: 100,
      };
      this.getAccountEmails();
    },
    removeFilter(index) {
      delete this.filters[index];
      this.indexf++;
    },
    getFilter() {},
  },
};
</script>
<!-- <style scoped>
.table-height-responsive {
  max-height: 700px; 
  overflow-y: auto;
}
</style> -->
